import React, { useState } from 'react';
import './App.css';

function About({ setCurrentPage }) {
  const [expandedOffering, setExpandedOffering] = useState(null);
  
  const toggleOffering = (index) => {
    setExpandedOffering(expandedOffering === index ? null : index);
  };
  return (
    <div className="App">
      <header className="header">
        <div className="container">
          <div className="logo">
            <span className="logo-icon"><img src='./s.png' height={40}></img></span>
          </div>
          <nav className="nav">
            <a href="#home" onClick={() => setCurrentPage('home')}>Home</a>
            <a href="#about" onClick={() => setCurrentPage('about')}>About</a>
            <a href="#designs" onClick={() => setCurrentPage('designs')}>Services</a>
           
            <a href="#contact" onClick={() => setCurrentPage('contact')}>Contact</a>
          </nav>
        </div>
      </header>
      
      <section className="group-companies-section">
        <div className="container">
          <div className="divider"></div>
          <h2>About ZM Consulting Services</h2>
          
          <div className="companies-grid">
            <div className="company-card">
            
              
              <ul>
                <h3>ZM Consulting Services - CHAP Certified</h3>
                <li>Home Health Consultation</li>
                <li>Hospice Care Consultation</li>
                <li>Home Care Consultation</li>
                <li>Survey Readiness</li>
                <li>Quality Assurance</li>
                <li>ADR/Appeal Support</li>
              </ul>
            </div>
            
            <div className="company-card">
            
             
              <ul>
                 <h3>Additional Services</h3>
                <li>Order Management</li>
                <li>Billing Process Optimization</li>
                <li>Regulatory Compliance Support</li>
                <li>Clinical Documentation Review</li>
                <li>Staff Training & Development</li>
                <li>Operational Workflow Improvement</li>
                <li>Performance Monitoring</li>
                <li>Risk Assessment & Mitigation</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      
      <section className="core-offerings-section">
        <div className="container">
          <h2 className="section-title">Core Healthcare Consulting Services</h2>
          <div className="core-offerings-content">
            <div className="offerings-image">
              <img src="./vertical.png" alt="Healthcare Consulting" />
            </div>
            <div className="offerings-text">
              <div className="offering-item">
                <div className="offering-header" onClick={() => toggleOffering(0)}>
                  <span className={`arrow ${expandedOffering === 0 ? 'expanded' : ''}`}>▶</span>
                  <h3>Home Health Consultation</h3>
                </div>
                {expandedOffering === 0 && (
                  <ul className="offering-details">
                    <li>Agency setup and operational improvement guidance</li>
                    <li>Regulatory and clinical standards compliance</li>
                    <li>Quality patient care assurance</li>
                    <li>Operational performance optimization</li>
                  </ul>
                )}
              </div>
              
              <div className="offering-item">
                <div className="offering-header" onClick={() => toggleOffering(1)}>
                  <span className={`arrow ${expandedOffering === 1 ? 'expanded' : ''}`}>▶</span>
                  <h3>Hospice Care Consultation</h3>
                </div>
                {expandedOffering === 1 && (
                  <ul className="offering-details">
                    <li>Compliant and compassionate care service establishment</li>
                    <li>Federal and state guidelines alignment</li>
                    <li>Patient outcomes strengthening</li>
                    <li>Agency readiness enhancement</li>
                  </ul>
                )}
              </div>
              
              <div className="offering-item">
                <div className="offering-header" onClick={() => toggleOffering(2)}>
                  <span className={`arrow ${expandedOffering === 2 ? 'expanded' : ''}`}>▶</span>
                  <h3>Survey Readiness & Quality Assurance</h3>
                </div>
                {expandedOffering === 2 && (
                  <ul className="offering-details">
                    <li>Mock audits and documentation review</li>
                    <li>Process improvements for compliance</li>
                    <li>Ongoing QA program development</li>
                    <li>Performance monitoring and deficiency correction</li>
                  </ul>
                )}
              </div>
              
              <div className="offering-item">
                <div className="offering-header" onClick={() => toggleOffering(3)}>
                  <span className={`arrow ${expandedOffering === 3 ? 'expanded' : ''}`}>▶</span>
                  <h3>ADR/Appeal & Order Management</h3>
                </div>
                {expandedOffering === 3 && (
                  <ul className="offering-details">
                    <li>ADR response and appeal management</li>
                    <li>Clinical and billing documentation accuracy</li>
                    <li>Physician order process streamlining</li>
                    <li>Timely completion and proper filing</li>
                  </ul>
                )}
              </div>
              
              <div className="offering-item">
                <div className="offering-header" onClick={() => toggleOffering(4)}>
                  <span className={`arrow ${expandedOffering === 4 ? 'expanded' : ''}`}>▶</span>
                  <h3>CHAP Certified Excellence</h3>
                </div>
                {expandedOffering === 4 && (
                  <ul className="offering-details">
                    <li><strong>Certified Quality:</strong> CHAP accredited consulting services</li>
                    <li><strong>Compliance:</strong> Regulatory standards and best practices</li>
                    <li><strong>Efficiency:</strong> Optimized billing and operational workflows</li>
                    <li><strong>Support:</strong> Comprehensive healthcare agency assistance</li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <span>Copyright © 2025 ZM Consulting Services</span>
            <span>Powered by ZM Consulting Services</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default About;